/* eslint-disable */
import { DateTime } from 'luxon';

/* Get the current instant */
const now = DateTime.now();

/**
 * Attachments are common and will be filled from here
 * to keep the demo data maintainable.
 */
const _attachments = {
    media: [
        'assets/images/cards/01-320x200.jpg',
        'assets/images/cards/02-320x200.jpg',
        'assets/images/cards/03-320x200.jpg',
        'assets/images/cards/04-320x200.jpg',
        'assets/images/cards/05-320x200.jpg',
        'assets/images/cards/06-320x200.jpg',
        'assets/images/cards/07-320x200.jpg',
        'assets/images/cards/08-320x200.jpg',
    ],
    docs : [],
    links: [],
};

/**
 *  If a message belongs to our user, it's marked by setting it as
 *  'me'. If it belongs to the user we are chatting with, then it
 *  left empty. We will be using this same conversation for each chat
 *  to keep things more maintainable for the demo.
 */
export const messages = [
    // {
    //     id       : 'e6b2b82f-b199-4a60-9696-5f3e40d2715d',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Hi!',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 18,
    //         minute: 56,
    //     }).toISO(),
    // },
    // {
    //     id       : 'eb82cf4b-fa93-4bf4-a88a-99e987ddb7ea',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Hey, dude!',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 4,
    //     }).toISO(),
    // },
    // {
    //     id       : '3cf9b2a6-ae54-47db-97b2-ee139a8f84e5',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Long time no see.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 4,
    //     }).toISO(),
    // },
    // {
    //     id       : '2ab91b0f-fafb-45f3-88df-7efaff29134b',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Yeah, man... Things were quite busy for me and my family.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 6,
    //     }).toISO(),
    // },
    // {
    //     id       : '10e81481-378f-49ac-b06b-7c59dcc639ae',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'What\'s up? Anything I can help with?',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 6,
    //     }).toISO(),
    // },
    // {
    //     id       : '3b334e72-6605-4ebd-a4f6-3850067048de',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'We\'ve been on the move, changed 3 places over 4 months',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 7,
    //     }).toISO(),
    // },
    // {
    //     id       : '25998113-3a96-4dd0-a7b9-4d2bb58db3f3',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Wow! That\'s crazy! 🤯 What happened?',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 7,
    //     }).toISO(),
    // },
    // {
    //     id       : '30adb3da-0e4f-487e-aec2-6d9f31e097f6',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'You know I got a job in that big software company. First move was because of that.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 8,
    //     }).toISO(),
    // },
    // {
    //     id       : 'c0d6fd6e-d294-4845-8751-e84b8f2c4d3b',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Then they decided to re-locate me after a month',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 8,
    //     }).toISO(),
    // },
    // {
    //     id       : '8d3c442b-62fa-496f-bffa-210ff5c1866b',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Which was an absolute pain because we just set up everything, house, kids school and all that.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 8,
    //     }).toISO(),
    // },
    // {
    //     id       : '3cf26ef0-e81f-4698-ac39-487454413332',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'So we moved the second time.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 9,
    //     }).toISO(),
    // },
    // {
    //     id       : '415151b9-9ee9-40a4-a4ad-2d88146bc71b',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'It\'s crazy!',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 9,
    //     }).toISO(),
    // },
    // {
    //     id       : '3a2d3a0e-839b-46e7-86ae-ca0826ecda7c',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Then this virus thing happened and just after a week we moved in, they decided the whole department will be working remotely.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 10,
    //     }).toISO(),
    // },
    // {
    //     id       : '5329c20d-6754-47ec-af8c-660c72be3528',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'And then we decided to move back our first location because, you know, everything was already setup so that\'s the third time.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 10,
    //     }).toISO(),
    // },
    // {
    //     id       : '415151b9-9ee9-40a4-a4ad-2d88146bc71b',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Ohh dude, I\'m really sorry you had to go through all that in such a short period of time',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 11,
    //     }).toISO(),
    // },
    // {
    //     id       : 'ea7662d5-7b72-4c19-ad6c-f80320541001',
    //     chatId   : '',
    //     contactId: '',
    //     value    : '😕',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 11,
    //     }).toISO(),
    // },
    // {
    //     id       : '3a2d3a0e-839b-46e7-86ae-ca0826ecda7c',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Thanks, man! It was good catching up with you.',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 11,
    //     }).toISO(),
    // },
    // {
    //     id       : '5329c20d-6754-47ec-af8c-660c72be3528',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Yeah dude. Hit me again next week so we can grab a coffee, remotely!',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 12,
    //     }).toISO(),
    // },
    // {
    //     id       : '5329c20d-6754-47ec-af8c-660c72be3528',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : ':) Sure, man! See you next week!',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 12,
    //     }).toISO(),
    // },
    // {
    //     id       : '5329c20d-6754-47ec-af8c-660c72be3528',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'See you later!',
    //     createdAt: now.minus({week: 1}).set({
    //         hour  : 19,
    //         minute: 12,
    //     }).toISO(),
    // },
    // {
    //     id       : 'bab8ca0e-b8e5-4375-807b-1c91fca25a5d',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Hey! Are you available right now? How about if we grab that coffee today? Remotely, of course :)',
    //     createdAt: now.set({
    //         hour  : 12,
    //         minute: 45,
    //     }).toISO(),
    // },
    // {
    //     id       : '8445a84d-599d-4e2d-a31c-5f4f29ad2b4c',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Hi!',
    //     createdAt: now.set({
    //         hour  : 12,
    //         minute: 56,
    //     }).toISO(),
    // },
    // {
    //     id       : '9f506742-50da-4350-af9d-61e53392fa08',
    //     chatId   : '',
    //     contactId: '',
    //     value    : 'Sure thing! I\'m gonna call you in 5, is it okay?',
    //     createdAt: now.set({
    //         hour  : 12,
    //         minute: 56,
    //     }).toISO(),
    // },
    // {
    //     id       : 'ca8523d8-faed-45f7-af09-f6bd5c3f3875',
    //     chatId   : '',
    //     contactId: 'me',
    //     value    : 'Awesome! Call me in 5 minutes..',
    //     createdAt: now.set({
    //         hour  : 12,
    //         minute: 58,
    //     }).toISO(),
    // },
    // {
    //     id       : '39944b00-1ffe-4ffb-8ca6-13c292812e06',
    //     chatId   : '',
    //     contactId: '',
    //     value    : '👍🏻',
    //     createdAt: now.set({
    //         hour  : 13,
    //         minute: 0,
    //     }).toISO(),
    // },
];
export const chats = [
    {
        id           : 'ff6bc7f1-449a-4419-af62-b89ce6cae0aa',
        contactId    : '9d3f0e7f-dcbd-4e56-a5e8-87b8154e9edf',
        unreadCount  : 2,
        muted        : false,
        lastMessage  : 'How can I assist you today?',
        lastMessageAt: '26/04/2021',
    },
];

export const contacts = [
    {
        id         : '9d3f0e7f-dcbd-4e56-a5e8-87b8154e9edf',
        avatar     : 'assets/images/avatars/gabby-guide-1.jpg',
        name       : 'Gabby, Your Guide Guru',
        about      : 'Hi there! I\'m your travel buddy.',
        details    : {
            emails      : [
                {
                    email: '',
                    label: '',
                },
                {
                    email: '',
                    label: '',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'zar',
                    phoneNumber: '',
                    label      : 'Mobile',
                },
            ],
            title       : 'AI assistant',
            company     : 'Travelfind.me',
            birthday    : '',
            address     : '',
        },
        attachments: _attachments,
    },
    {
        id         : 'bf172879-423a-4fd6-8df3-6d1938bbfe1f',
        avatar     : '',
        name       : 'Phinda',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'edwardsmckenzie@mail.org',
                    label: 'Personal',
                },
                {
                    email: 'mckenzie.edwards@bugsall.io',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'pe',
                    phoneNumber: '934 519 2903',
                    label      : 'Mobile',
                },
                {
                    country    : 'pe',
                    phoneNumber: '989 489 3662',
                    label      : 'Work',
                },
                {
                    country    : 'pe',
                    phoneNumber: '813 461 2790',
                    label      : 'Home',
                },
            ],
            title       : 'Legal Assistant',
            company     : 'Bugsall',
            birthday    : '1988-07-27T12:00:00.000Z',
            address     : '384 Polhemus Place, Dalton, Palau, PO6038',
        },
        attachments: _attachments,
    },
    {
        id         : 'abd9e78b-9e96-428f-b3ff-4d934c401bee',
        avatar     : '',
        name       : 'Progress Mawupa',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'elsiemelendez@mail.com',
                    label: 'Personal',
                },
                {
                    email: 'melendez.elsie@chillium.name',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'tg',
                    phoneNumber: '907 515 3007',
                    label      : 'Mobile',
                },
                {
                    country    : 'tg',
                    phoneNumber: '967 534 2803',
                    label      : 'Work',
                },
            ],
            title       : 'Fundraising Director',
            company     : 'Chillium',
            birthday    : '1980-06-28T12:00:00.000Z',
            address     : '428 Varanda Place, Veyo, Oklahoma, PO6188',
        },
        attachments: _attachments,
    },
    {
        id         : '6519600a-5eaa-45f8-8bed-c46fddb3b26a',
        background : '',
        name       : 'Angelique Lategan',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'mcleodwagner@mail.biz',
                    label: 'Personal',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'at',
                    phoneNumber: '977 590 2773',
                    label      : 'Mobile',
                },
                {
                    country    : 'at',
                    phoneNumber: '828 496 3813',
                    label      : 'Work',
                },
                {
                    country    : 'at',
                    phoneNumber: '831 432 2512',
                    label      : 'Home',
                },
            ],
            company     : 'Inrt',
            birthday    : '1980-12-03T12:00:00.000Z',
            address     : '736 Glen Street, Kaka, West Virginia, PO9350',
        },
        attachments: _attachments,
    },
    {
        id         : 'b62359fd-f2a8-46e6-904e-31052d1cd675',
        avatar     : '',
        name       : 'Sarah',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'josephstrickland@mail.io',
                    label: 'Personal',
                },
                {
                    email: 'strickland.joseph@bytrex.us',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'jo',
                    phoneNumber: '990 450 2729',
                    label      : 'Mobile',
                },
            ],
            title       : 'Hotel Manager',
            company     : 'Bytrex',
            birthday    : '1991-09-08T12:00:00.000Z',
            address     : '844 Ellery Street, Hondah, Texas, PO1272',
        },
        attachments: _attachments,
    },
    {
        id         : '16b9e696-ea95-4dd8-86c4-3caf705a1dc6',
        avatar     : '',
        name       : 'Megan Siebritz',
        about      : '',
        details    : {
            emails      : [
                {
                    email: '',
                    label: 'Personal',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'xk',
                    phoneNumber: '909 552 3327',
                    label      : 'Mobile',
                },
            ],
            title       : 'Hotel Manager',
            company     : 'Buzzopia',
            birthday    : '1982-01-23T12:00:00.000Z',
            address     : '614 Herkimer Court, Darrtown, Nebraska, PO9308',
        },
        attachments: _attachments,
    },
    {
        id         : '2c37ed00-427a-46d7-8f8f-d711c768d1ee',
        avatar     : '',
        name       : 'Angelique Lategan',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'silvafoster@mail.net',
                    label: 'Personal',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'bn',
                    phoneNumber: '916 511 3837',
                    label      : 'Mobile',
                },
                {
                    country    : 'bn',
                    phoneNumber: '949 564 3247',
                    label      : 'Work',
                },
            ],
            title       : 'Insurance Analyst',
            company     : 'Extrawear',
            birthday    : '1980-04-29T12:00:00.000Z',
            address     : '137 Bridge Street, Sisquoc, District Of Columbia, PO4105',
        },
        attachments: _attachments,
    },
    {
        id         : 'b8258ccf-48b5-46a2-9c95-e0bd7580c645',
        avatar     : '',
        name       : 'Alanna Wilsnach',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'tinaharris@mail.ca',
                    label: 'Personal',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'gp',
                    phoneNumber: '933 464 2431',
                    label      : 'Mobile',
                },
                {
                    country    : 'gp',
                    phoneNumber: '894 535 3609',
                    label      : 'Work',
                },
            ],
            title       : 'Short Story Writer',
            company     : 'Gallaxia',
            birthday    : '1976-09-10T12:00:00.000Z',
            address     : '821 Beverly Road, Tyro, Colorado, PO4248',
        },
        attachments: _attachments,
    },
    {
        id         : 'e2946946-b4b5-4fd7-bab4-62c38cdff2f1',
        avatar     : '',
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        
        attachments: _attachments,
    },
    {
        id         : '12148fa2-e0a4-49fb-b3c5-daeecdb5180a',
        avatar     : '',
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'olgarhodes@mail.me',
                    label: 'Personal',
                },
                {
                    email: 'rhodes.olga@moreganic.info',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'tl',
                    phoneNumber: '971 514 3366',
                    label      : 'Mobile',
                },
                {
                    country    : 'tl',
                    phoneNumber: '807 480 2033',
                    label      : 'Work',
                },
                {
                    country    : 'tl',
                    phoneNumber: '810 528 3783',
                    label      : 'Home',
                },
            ],
            title       : 'Pastry Baker',
            company     : 'Moreganic',
            birthday    : '1971-08-13T12:00:00.000Z',
            address     : '253 Beard Street, Staples, Massachusetts, PO8089',
        },
        attachments: _attachments,
    },
    {
        id         : '81fdc48c-5572-4123-8a73-71b7892120de',
        avatar     : '',
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'earlenerosales@mail.co.uk',
                    label: 'Personal',
                },
                {
                    email: 'rosales.earlene@softmicro.net',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'ki',
                    phoneNumber: '927 589 3619',
                    label      : 'Mobile',
                },
            ],
            title       : 'Historiographer',
            company     : 'Softmicro',
            birthday    : '1960-11-13T12:00:00.000Z',
            address     : '981 Kingston Avenue, Topaz, Connecticut, PO6866',
        },
        attachments: _attachments,
    },
    {
        id         : 'a9a9f382-e4c3-42fb-9fe9-65aa534732b5',
        avatar     : '',
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'franciscaperkins@mail.tv',
                    label: 'Personal',
                },
                {
                    email: 'perkins.francisca@overplex.com',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'au',
                    phoneNumber: '830 430 3437',
                    label      : 'Mobile',
                },
                {
                    country    : 'au',
                    phoneNumber: '868 538 2886',
                    label      : 'Work',
                },
            ],
            title       : 'Dental Laboratory Worker',
            company     : 'Overplex',
            birthday    : '1966-08-14T12:00:00.000Z',
            address     : '733 Delmonico Place, Belvoir, Virginia, PO7102',
        },
        attachments: _attachments,
    },
    {
        id         : '7e8e1f1e-d19f-45c7-86bd-6fef599dae71',
        avatar     : '',
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'margowitt@mail.ca',
                    label: 'Personal',
                },
                {
                    email: 'witt.margo@norsul.org',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'ao',
                    phoneNumber: '992 596 3391',
                    label      : 'Mobile',
                },
                {
                    country    : 'ao',
                    phoneNumber: '950 489 2505',
                    label      : 'Work',
                },
                {
                    country    : 'ao',
                    phoneNumber: '891 540 2231',
                    label      : 'Home',
                },
            ],
            title       : 'Television News Producer',
            company     : 'Norsul',
            birthday    : '1975-08-31T12:00:00.000Z',
            address     : '539 Rockaway Avenue, Whitmer, Guam, PO4871',
        },
        attachments: _attachments,
    },
    {
        id         : '8141dd08-3a6e-4770-912c-59d0ed06dde6',
        avatar     : null,
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'madeleinefletcher@mail.info',
                    label: 'Personal',
                },
                {
                    email: 'fletcher.madeleine@genmom.biz',
                    label: 'Work',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'uy',
                    phoneNumber: '898 554 3354',
                    label      : 'Mobile',
                },
            ],
            title       : 'Fundraising Director',
            company     : 'Genmom',
            birthday    : '1970-07-15T12:00:00.000Z',
            address     : '825 Cherry Street, Foscoe, Minnesota, PO7290',
        },
        attachments: _attachments,
    },
    {
        id         : '114642a2-ccb7-4cb1-ad2b-5e9b6a0c1d2e',
        avatar     : '',
        name       : '',
        about      : 'Hi there! I\'m using FuseChat.',
        details    : {
            emails      : [
                {
                    email: 'barberjohnson@mail.org',
                    label: 'Personal',
                },
            ],
            phoneNumbers: [
                {
                    country    : 'az',
                    phoneNumber: '928 567 2521',
                    label      : 'Mobile',
                },
                {
                    country    : 'az',
                    phoneNumber: '898 515 2048',
                    label      : 'Work',
                },
                {
                    country    : 'az',
                    phoneNumber: '935 495 3348',
                    label      : 'Home',
                },
            ],
            title       : 'Talent Manager',
            company     : 'Zounds',
            birthday    : '1967-03-02T12:00:00.000Z',
            address     : '386 Vernon Avenue, Dragoon, North Carolina, PO4559',
        },
        attachments: _attachments,
    },
    
];
export const profile: any = {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name  : 'Brian Hughes',
    email : 'hughes.brian@company.com',
    avatar: 'assets/images/avatars/brian-hughes.jpg',
    about : 'Hi there! I\'m using FuseChat.',
};
